import React from "react";
import { useGetLastUpdatedQuery } from "../../../redux/services/internal/apiHome";



const LastUpdated = () => {
  const { data: lastUpdate = {} } = useGetLastUpdatedQuery();

  return (
    <p>
    Last Updated: <span>{lastUpdate.data}</span>
    </p>
  );
};

export default LastUpdated;
